module.exports = __webpack_public_path__ + "187608a4cc4827a034c7e3f88c690cfd.svg";